/**
 * useGlobalScanner — ilova bo'ylab global skaner tinglovchisi.
 *
 * Foydalanuvchi QAYERDA bo'lishidan qat'i nazar barcode skaner qilsa —
 * avtomatik /kassa ga o'tib mahsulotni savatga qo'shadi (Faza 3C).
 *
 * XAVFSIZLIK: faqat input/textarea/select fokusda BO'LMAGANDA ishlaydi —
 * shunda forma/qidiruvga yozishga umuman xalal bermaydi (kassa qidiruv qutisi
 * o'z skanerini o'zi boshqaradi). Tez (skaner) kiritma aniqlanadi: belgilar
 * <100ms oralig'ida kelsa skaner; sekin (qo'lda) bo'lsa bufer tiklanadi.
 * 8-belgili bo'lib bo'linadi (Enter'siz skaner concat uchun).
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { processScanCodes } from './scan-to-cart';

export function useGlobalScanner(): void {
  const navigate = useNavigate();
  useEffect(() => {
    let buffer = '';
    let lastTime = 0;
    let timer: ReturnType<typeof setTimeout> | null = null;

    const onKey = (e: KeyboardEvent): void => {
      // Forma/qidiruvga yozishga xalal bermaslik — input fokusda bo'lsa chetlanamiz
      const tag = (document.activeElement?.tagName ?? '').toUpperCase();
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if ((document.activeElement as HTMLElement | null)?.isContentEditable === true) {
        return;
      }
      // Faqat bitta bosma alfanumerik belgi (skaner chiqishi)
      if (e.key.length !== 1 || !/[A-Za-z0-9]/.test(e.key)) return;

      const now = Date.now();
      if (now - lastTime > 100) buffer = ''; // idle/sekin (qo'lda) → yangi sekvensiya
      lastTime = now;
      buffer += e.key;

      if (timer !== null) clearTimeout(timer);
      timer = setTimeout(() => {
        const raw = buffer;
        buffer = '';
        if (raw.length < 4) return; // juda qisqa — skaner emas
        void processScanCodes(raw).then((added) => {
          if (added) void navigate('/kassa');
        });
      }, 120);
    };

    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      if (timer !== null) clearTimeout(timer);
    };
  }, [navigate]);
}
